export const PRIMARY_PAYMENT_RECEIVE = {
    BASE_PATH: '/sale-order/payment-receive/',
    ADD_PATH() {
        return this.BASE_PATH + 'add';
    },
    LIST_PAGE_TITLE: 'Primary Sale Order List',
    EDIT_PAGE_TITLE: 'Edit Primary Sale Order',
    GET_ALL: 'sale-order/payment-receive',
    GET_ONE: 'sale-order/payment-receive/edit/',
    CREATE: 'sale-order/payment-receive/create',
    UPDATE: 'sale-order/payment-receive/update/',
    DELETE: 'sale-order/payment-receive/delete/',
};
